import { Link } from 'react-router-dom'
import { Users, Wrench, Tags, TrendingUp, FileBadge, Map, MapPin, UserCog, SlidersHorizontal } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { PageHeader } from '@/components/ui/page-header'

const cadastros = [
  { to: '/cadastro/clientes', label: 'Clientes', desc: 'Tomadores das NFs', icon: Users },
  { to: '/cadastro/servicos', label: 'Serviços', desc: 'Serviços dos contratos', icon: Wrench },
  { to: '/cadastro/modalidades', label: 'Modalidades', desc: 'Modalidades de compra', icon: Tags },
  { to: '/cadastro/indices-reajuste', label: 'Índices de Reajuste', desc: 'IPCA, INPC, etc.', icon: TrendingUp },
  { to: '/cadastro/tributacoes', label: 'Tributação Nacional', desc: 'Códigos LC 116/2003', icon: FileBadge },
  { to: '/cadastro/estados', label: 'Estados', desc: 'UFs', icon: Map },
  { to: '/cadastro/municipios', label: 'Municípios', desc: 'IBGE', icon: MapPin },
  { to: '/cadastro/usuarios', label: 'Usuários', desc: 'Acesso ao sistema', icon: UserCog },
  { to: '/cadastro/parametros', label: 'Parâmetros', desc: 'Alíquota padrão', icon: SlidersHorizontal },
]

export default function CadastroIndex() {
  return (
    <div className="flex flex-col h-full">
      <PageHeader title="Cadastros" subtitle="Cadastros auxiliares do sistema." />

      <div className="flex-1 overflow-auto p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cadastros.map(({ to, label, desc, icon: Icon }) => (
          <Link key={to} to={to}>
            <Card className="p-5 flex items-center gap-4 hover:border-primary hover:shadow-md transition-all">
              <div className="h-11 w-11 rounded-lg bg-accent flex items-center justify-center text-primary">
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <div className="font-medium">{label}</div>
                <div className="text-sm text-muted-foreground">{desc}</div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
      </div>
    </div>
  )
}
